<!--
 * @Description: 服务事项配置页面
 * @Author: sunhuihong
 * @Date: 2022-05-26 15:43:52
 * @LastEditTime: 2022-05-30 17:47:03
-->
<template>
  <div class="body">
    <div class="hsvc-mattercfg-header">
      <div class="hsvc-mattercfg-tabs">
        <span class="hsvc-mattercfg-tabs-item" @click="changeTabsStatus(index)" v-for="(item, index) in tabsList" 
          :key="index" :class="{ active: index == currentTabIndex }" >
          {{ item.text }}
        </span>
      </div>
    </div>
    <div class="matter-main-line"></div>
    <div class="back-card">
      <!-- 服务事项模板组件 -->
      <matter-cfg-details v-if="currentTabIndex == 0" :matterCfgData="matterCfgData" 
        :currentMatterCfgData="currentMatterCfgData"  @handle-add-group="handleAddGroup" 
        @handle-add-template="handleAddTemplate" @handle-edit-name="handleEditName"
        @handle-delete-group="handleDeleteGroup"/>
      
      <!-- 服务宣传语组件 -->
      <slogan-cfg v-else :sloganCfgData="sloganCfgData" @add-slogan-cfg="handleAddSloganCfg" 
        @edit-slogan-cfg="handleEditSloganCfg" 
        @delete-slogan-cfg="handleDeleteSloganCfg"/>
    </div>
    
    <!-- 新增组对话框 -->
    <add-group-dialog :showAddGroupDialog="showAddGroupDialog"  :serviceItemId="serviceItemId" :mode="groupMode"
      @add-group-data="addGroupData"  @handle-close-group-dialog="handleCloseGroupDialog"/>

    <!-- 新增模板对话框 -->
    <add-template-dialog :showAddTemplateDialog="showAddTemplateDialog"  :serviceItemId="serviceItemId" 
      :parentId="parentId" :mode="templateMode" @add-templete-data="addTempleteData" 
      @handle-close-template-dialog="handleCloseTemplateDialog"/>
    
    <!-- 删除组对话框 -->
    <delete-group-dialog :showDeleteGroupDialog="showDeleteGroupDialog" 
      :deleteCurrentMatterCfgData="deleteCurrentMatterCfgData" 
      @handle-close-delete-dialog="handleCloseDeleteDialog"/>

    <!-- 服务宣传语对话框 -->
    <slogan-cfg-dialog :showSloganCfgDialog="showSloganCfgDialog" :sloganCfgOperate="sloganCfgOperate" 
      :sloganCfgId="sloganCfgId" @close-slogan-cfg-dialog="handleCloseSloganCfgDialog"/>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import MatterCfgDetails from './components/MatterCfgDetails.vue'
import SloganCfg from './components/SloganCfg.vue'
import SloganCfgDialog from './components/sloganCfg/SloganCfgDialog.vue'
import AddGroupDialog from './components/matterCfgDetails/AddMatterCfgGroupDialog.vue'
import AddTemplateDialog from './components/matterCfgDetails/AddMatterCfgTemplateDialog.vue'
import DeleteGroupDialog from './components/matterCfgDetails/DeleteMatterCfgDetailsDialog.vue'

export default {
  name: "HsvcMatterCfg",
  components: { 
    'matter-cfg-details': MatterCfgDetails,
    'slogan-cfg': SloganCfg,
    'slogan-cfg-dialog': SloganCfgDialog,
    'add-group-dialog': AddGroupDialog,
    'add-template-dialog': AddTemplateDialog,
    'delete-group-dialog': DeleteGroupDialog,
  },

  data() {
    return {
      tabsList: [{ text: "服务事项模板" }, { text: "服务宣传语" }],
      currentTabIndex: 0,//当前tabs的index值

      //以下是相关服务宣传语数据
      sloganCfgData: {},
      showSloganCfgDialog: false, //是否显示服务宣传语dialog
      sloganCfgOperate: '',
      sloganCfgId: '',

      //以下是相关服务事项模板数据
      matterCfgData: [],
      currentMatterCfgData: [],
      deleteCurrentMatterCfgData: {},
      showAddGroupDialog: false,//是否显示新增组dialog
      showAddTemplateDialog: false,//是否显示新增模板dialog
      showDeleteGroupDialog: false,//是否显示删除组dialog
      serviceItemId: '',
      groupMode: '',
      templateMode: '',
      parentId: '',
    };
  },
  
  methods: {
    changeTabsStatus(index) {
      this.currentTabIndex = index;
      if (index == 1) {
        this.getSloganCfgData();
      } else {
        this.getMatterCfgData();
      }
    },

    //获取服务事项数据
    getMatterCfgData() {
      let header = this.encryptionUtil.signatureParams({},
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_TREE_MATTER_CFGS,
        param: {},
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.matterCfgData = result.data;
        }
      });
    },
    
    //获取服务宣传语数据
    getSloganCfgData() {
      this.appAxios("GET", Constant.URL_GET_SLOGAN_CFG_DO_LIST).then((result) => {
        if (result != null) {
          this.sloganCfgData = result.data;
        }
      });
    },

    //删除服务宣传语标签
    deleteSloganCfg(data) {
      let params = {id: data.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_SLOGAN_CFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if(result == null) {
          return;
        }
        this.getSloganCfgData();
      });
    },

    //以下事件用于处理服务宣传语组件调用
    handleAddSloganCfg() {
      this.sloganCfgOperate = 'add';
      this.showSloganCfgDialog = true;
    },

    handleEditSloganCfg(data) {
      this.sloganCfgOperate = 'edit';
      this.sloganCfgId = data.id;
      this.showSloganCfgDialog = true;
    },

    handleDeleteSloganCfg(data) {
      this.$confirm('确认是否删除保障宣传标签?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.deleteSloganCfg(data);
      })
    },

    handleCloseSloganCfgDialog(refresh) {
      this.showSloganCfgDialog = false;
      if (refresh) {
        this.getSloganCfgData();
      }
    },
     

    //以下事件用于处理服务事项模板组件调用
    handleAddGroup() {
      this.groupMode = 'add';
      this.serviceItemId  = null;
      this.showAddGroupDialog = true;
    },

    addGroupData(data) {
      this.currentMatterCfgData = data;
    },

    //取消新增组dialog
    handleCloseGroupDialog(refresh) {
      this.showAddGroupDialog = false;
      if(refresh) this.getMatterCfgData();
    },

    //新增模板
    handleAddTemplate(data) {
      this.templateMode = 'add';
      this.serviceItemId = data.id;
      this.parentId = data.id;
      this.showAddTemplateDialog = true;
    },

    addTempleteData(data) {
      this.currentMatterCfgData = data;
    },

    //关闭新增/编辑模板对话框
    handleCloseTemplateDialog(refresh) {
      this.showAddTemplateDialog = false;
      if(refresh) this.getMatterCfgData();
    },

    //修改名称(组名称以及模板名称通过parentId判断当前是修改组名称还是模板名称)
    handleEditName(data) {
      if (data.parentId == 0) {
        this.groupMode = 'edit';
        this.serviceItemId = data.id;
        this.showAddGroupDialog = true;
      } else {
        this.templateMode = 'edit';
        this.serviceItemId = data.id;
        this.showAddTemplateDialog = true;
      }
    },

    //删除组或者模板
    handleDeleteGroup(data) {
      this.currentMatterCfgData = {'choiceId': ''};
      this.deleteCurrentMatterCfgData = data;
      this.showDeleteGroupDialog = true;
    },

    //关闭删除组或者模板dialog
    handleCloseDeleteDialog(refresh) {
      this.showDeleteGroupDialog = false;
      if(refresh) this.getMatterCfgData();
    },

  },

  mounted() {
    this.$emit("breadcrumb", {text1: '服务配置', text2: '服务事项配置'});
    this.getMatterCfgData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
  overflow-x: hidden;
}

.hsvc-mattercfg-header {
  text-align: left;
  margin-left: 40px;
  padding-bottom: 16px;
}

.hsvc-mattercfg-tabs {
  display: flex;
  flex-direction: row;
}

.hsvc-mattercfg-tabs-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3e7ef5;
  background-color: white;
  font-size: 14px;
  width: 110px;
  height: 24px;
  line-height: 24px;
  border-radius: 14px;
  margin-right: 52px;
  cursor: pointer;
}

.active {
  color: white;
  background-color: #3e7ef5;
}

.matter-main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.back-card {
  margin-left: 21px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvccfg/HsvcMatterCfg.vue